import { isDefined, isNonEmpty } from '@sgme/fp';
import type { ReactElement } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { ErrorRates } from '@/App/tiles/shared/ErrorRates';
import { getFlexiForwardRfsId } from '@/store/flexi-forward/helpers/rfs.ts';

export function StreamingError(): ReactElement {
  const { errorCode, errorMessage, multipassErrorCode, rfsId } = useFlexiForwardSelector((flexiForward) => {
    const rfsState = flexiForward.properties.rfs;
    const rfsId = getFlexiForwardRfsId(rfsState);

    if (rfsState?.status !== 'ERROR') {
      return {
        errorCode: undefined,
        errorMessage: undefined,
        multipassErrorCode: undefined,
        rfsId: rfsId,
        predealChecks: [],
      };
    }

    return {
      errorCode: rfsState.error.errorCode,
      errorMessage: rfsState.error.errorMessage,
      multipassErrorCode: rfsState.error.multipassErrorCode,
      rfsId,
      predealChecks: [],
    };
  });

  function computeErrorTranslationKey(errorCode: string, errorMessage: string): string {
    const newErrorCode = errorMessage.substring(0, errorMessage.indexOf('|'));
    if (isNonEmpty(newErrorCode)) {
      return `${newErrorCode}_${errorCode}`;
    }
    return errorCode;
  }

  const errorKey =
    isDefined(errorMessage) && isDefined(errorCode) ? computeErrorTranslationKey(errorCode, errorMessage) : errorCode;

  const multipass = isDefined(errorCode)
    ? { code: multipassErrorCode, sessionId: rfsId, predealChecks: [] }
    : undefined;

  return <ErrorRates code={errorKey} message={errorMessage} multipass={multipass} />;
}
